define('lq/modalblur',[
    'jquery'
], function ($) {

    var setBlurValue = function(value) {
        if (!this.data.centered)
            return;

        var $rootWrapper = this.piping.$app.children('.licquid-action-wrapper');

        setTimeout(function () {
            if (navigator.userAgent.search("Firefox") > -1) {
                if (value === 0) {
                    $rootWrapper.css({ animation: 'zoom-out 600ms forwards' });
                } else {
                    $rootWrapper.css({ animation: 'zoom-in 600ms forwards' });
                }
            }

            var cssValue = value > 0
                ? 'blur(' + value + 'px)'
                : 'none';

            $rootWrapper.children().each(function() {
                $(this).css('backdrop-filter', cssValue);

                $(this).children().each(function() {
                    $(this).css('filter', cssValue);
                });
            });
        });
    };

    var applyBlur = function () {
        if ((this.data.blur !== null || this.data.blur !== undefined) && this.data.hasBlur) {
            setBlurValue.call(this, this.data.blur);
        } else if (this.data.hasBlur) {
            setBlurValue.call(this, 0);
        }
    };

    var updateModalLayerHeight = function () {
        if (this.$modalLayer && this.$scrollContainer) {
            this.$modalLayer.css({height: this.$scrollContainer.prop('scrollHeight')});
        }
    };

    return {
        applyBlur: applyBlur,
        setBlurValue: setBlurValue,
        updateModalLayerHeight: updateModalLayerHeight
    };
});

